import {
  PhoneOutlined,
  MailOutlined,
  FieldTimeOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Row, Typography } from 'antd';

import { AvatarDropdownItems, LogoutModal } from '@app/components';
import { Avatar } from '@app/components/Avatar';

import type { NUserProfile } from '@pages/Users/UserProfile/UserProfile.types';

const { Text } = Typography;

export const PersonalInfo: NUserProfile.Main = ({
  currentUser,
  isModalOpen,
  showModal,
  uploadAvatar,
  deleteAvatar,
  newPhoto,
  setIsModalOpen,
  currentPhoneNumber,
}) => {
  const items = AvatarDropdownItems({
    uploadAvatar,
    deleteAvatar,
    Photo: currentUser?.Photo || undefined,
  });

  return (
    <div className="personal-info-container">
      <div className="photo-container">
        <Avatar
          src={newPhoto || currentUser?.Photo}
          nameFirst={currentUser?.NameFirst}
          nameLast={currentUser?.NameLast}
          className="image"
          size={100}
        />

        <Dropdown menu={{ items }}>
          <Button type="link" data-testid="change-photo">
            Изменить
          </Button>
        </Dropdown>
      </div>

      <div className="info-container">
        <Row className="item-container">
          <Text data-testid="user-phone">
            <PhoneOutlined />
            {currentPhoneNumber}
          </Text>
        </Row>
        <Row className="item-container">
          <Text data-testid="user-email">
            <MailOutlined />
            {currentUser?.Email}
          </Text>
        </Row>
        <Row className="item-container" data-testid="local-time">
          <Text>
            <FieldTimeOutlined />
            {currentUser?.Timezone}
          </Text>
        </Row>

        <Button
          style={{ marginTop: '15px', maxWidth: '150px' }}
          danger
          onClick={showModal}
          data-testid="logout"
        >
          Выход из аккаунта
        </Button>
      </div>

      <LogoutModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  );
};
